export const TOP_SQL_OTHERS_LABEL = 'Others'

function normalizeValue(value?: string | null) {
  return value?.trim() || ''
}

export function resolveTopSQLIdentity(
  sqlText?: string | null,
  sqlDigest?: string | null
) {
  const normalizedSqlText = normalizeValue(sqlText)
  const normalizedSqlDigest = normalizeValue(sqlDigest)
  const isOthers = !normalizedSqlText && !normalizedSqlDigest

  return {
    sqlText: normalizedSqlText,
    sqlDigest: normalizedSqlDigest,
    isOthers,
    displayName:
      normalizedSqlText || normalizedSqlDigest || TOP_SQL_OTHERS_LABEL
  }
}

export function isTopSQLOthersLabel(value?: string | null) {
  return normalizeValue(value) === TOP_SQL_OTHERS_LABEL
}
